import { Button } from './primitives/Button.js';
import { Card, Container, Tag } from './primitives/Misc.js';
import './Systems.css';

export interface SystemsProps {
  onGoDocs: () => void;
}

interface SystemGroup {
  label: string;
  body: string;
  tags: string[];
}

const GROUPS: SystemGroup[] = [
  {
    label: 'Marketing & sales',
    body: 'Duplicate contacts inflate your subscriber count, your seat count and your attribution.',
    tags: ['CRM', 'email platform', 'ads audiences', 'events & webinars'],
  },
  {
    label: 'Finance & billing',
    body: 'The same company invoiced under three spellings is a reconciliation problem, not a data problem — until it is both.',
    tags: ['accounting ledger', 'payments', 'subscriptions', 'expenses'],
  },
  {
    label: 'Support, docs & ops',
    body: 'Tickets against the wrong account, contracts nobody has opened in two years, four versions of one price list.',
    tags: ['helpdesk', 'document store', 'ERP / inventory', 'HR & payroll'],
  },
];

export function Systems({ onGoDocs }: SystemsProps) {
  return (
    <Container id="systems" className="land-section">
      <div className="land-section__head">
        <h2 className="land-section__title">
          Not just your CRM. Every system your business keeps customer data in.
        </h2>
        <p className="land-section__lede land-section__lede--narrow">
          Marketing, sales, finance, support, documents, spreadsheets — plus anything with a REST
          API or a CSV export.
        </p>
      </div>
      <div className="land-systems__grid">
        {GROUPS.map((group) => (
          <Card key={group.label}>
            <div className="land-mono-label">{group.label}</div>
            <p className="land-systems__body">{group.body}</p>
            <div className="land-systems__tags">
              {group.tags.map((tag) => (
                <Tag key={tag}>{tag}</Tag>
              ))}
            </div>
          </Card>
        ))}
        <Card tone="tint">
          <div className="land-mono-label">Anything else</div>
          <p className="land-systems__body land-systems__body--tint">
            A REST endpoint, a database view, or a CSV/XLSX upload you can delete whenever you
            like. Same matching engine, no OAuth needed.
          </p>
          <Button variant="tint-outline" size="sm" onClick={onGoDocs}>
            Connector list &amp; API →
          </Button>
        </Card>
      </div>
    </Container>
  );
}
